var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "账号信息", width: 60 },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "userDistributionStationForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.userDistributionStationForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "登录账号", prop: "userName" } },
                    [
                      _c("Input", {
                        attrs: {
                          readonly:
                            _vm.formEditMode === _vm.FORM_EDIT_MODE_MODIFY,
                        },
                        model: {
                          value: _vm.userDistributionStationForm.userName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userDistributionStationForm,
                              "userName",
                              $$v
                            )
                          },
                          expression: "userDistributionStationForm.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "姓名",
                        prop: "userDistributionStationName",
                      },
                    },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userDistributionStationForm
                              .userDistributionStationName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userDistributionStationForm,
                              "userDistributionStationName",
                              $$v
                            )
                          },
                          expression:
                            "userDistributionStationForm.userDistributionStationName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "所属转运站",
                        prop: "userDistributionStationRelateStationUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userDistributionStationForm
                                .userDistributionStationRelateStationUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userDistributionStationForm,
                                "userDistributionStationRelateStationUuid",
                                $$v
                              )
                            },
                            expression:
                              "userDistributionStationForm.userDistributionStationRelateStationUuid",
                          },
                        },
                        _vm._l(
                          _vm.distributionStationSource,
                          function (item, index) {
                            return _c(
                              "Option",
                              {
                                key: index,
                                attrs: { value: item.distributionStationUuid },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.distributionStationCode +
                                      " - " +
                                      item.distributionStationName
                                  )
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "手机",
                        prop: "userDistributionStationPhone",
                      },
                    },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userDistributionStationForm
                              .userDistributionStationPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userDistributionStationForm,
                              "userDistributionStationPhone",
                              $$v
                            )
                          },
                          expression:
                            "userDistributionStationForm.userDistributionStationPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "审批" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value:
                              _vm.userDistributionStationForm
                                .userDistributionStationApproval,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userDistributionStationForm,
                                "userDistributionStationApproval",
                                $$v
                              )
                            },
                            expression:
                              "userDistributionStationForm.userDistributionStationApproval",
                          },
                        },
                        _vm._l(_vm.approvalSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) + "\n                    "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码确认" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function ($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }